import _slicedToArray from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/Users/francesco/Dropbox/Mac/Documents/GitHub/DFN-GRP-Web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
// src/providers.tsx
import { useColorMode } from "@chakra-ui/color-mode";
import { createContext } from "@chakra-ui/react-utils";
import { css, toCSSVar } from "@chakra-ui/styled-system";
import { memoizedGet as get, runIfFn } from "@chakra-ui/utils";
import { Global, ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
function ThemeProvider(props) {
  var cssVarsRoot = props.cssVarsRoot,
    theme = props.theme,
    children = props.children;
  var computedTheme = useMemo(function () {
    return toCSSVar(theme);
  }, [theme]);
  return /* @__PURE__ */jsxs(EmotionThemeProvider, {
    theme: computedTheme,
    children: [/* @__PURE__ */jsx(CSSVars, {
      root: cssVarsRoot
    }), children]
  });
}
function CSSVars(_ref) {
  var _ref$root = _ref.root,
    root = _ref$root === void 0 ? ":host, :root" : _ref$root;
  var selector = [root, "[data-theme]"].join(",");
  return /* @__PURE__ */jsx(Global, {
    styles: function styles(theme) {
      return _defineProperty({}, selector, theme.__cssVars);
    }
  });
}
var _createContext = createContext({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  StylesProvider = _createContext2[0],
  useStyles = _createContext2[1];
function createStylesContext(componentName) {
  return createContext({
    name: "".concat(componentName, "StylesContext"),
    errorMessage: "useStyles: \"styles\" is undefined. Seems you forgot to wrap the components in \"<".concat(componentName, " />\" ")
  });
}
function GlobalStyle() {
  var _useColorMode = useColorMode(),
    colorMode = _useColorMode.colorMode;
  return /* @__PURE__ */jsx(Global, {
    styles: function styles(theme) {
      var styleObjectOrFn = get(theme, "styles.global");
      var globalStyles = runIfFn(styleObjectOrFn, {
        theme: theme,
        colorMode: colorMode
      });
      if (!globalStyles) return void 0;
      var styles = css(globalStyles)(theme);
      return styles;
    }
  });
}
export { ThemeProvider, CSSVars, StylesProvider, useStyles, createStylesContext, GlobalStyle };